// extracted by mini-css-extract-plugin
export default {"container":"ux83lW","noSeparators":"Hs9jOp","section":"bVF0DD","mainSection":"lnKYSq","bottomSection":"xIs1Bi","stats":"asGom3","comments":"LATRtv"};